import React from 'react';

import {
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import { useTranslation } from 'react-i18next';

import './style.scss';
import { CoreLink } from '@uncinc/react-drupal-core';
import { ROUTE_CUSTOMER_SERVICE } from '../../../../../config/routes';

const CheckoutRegister = ({ goToRegister }) => {
  const { t } = useTranslation();

  return (
    <div className="CheckoutRegister col-12 col-md-5">
      <h3>{t('form.register.veiligheid_title')}</h3>
      <p>{t('form.register.intro')}</p>
      <Button className="Button Button--primary CheckoutRegister__submit" onClick={goToRegister}>{t('form.register.submit')} <i className="icon icon-arrow-right" /> </Button>

      <b>{t('form.register.usp.title')}</b>

      <ul>
        <li>{t('form.register.usp.usp_1')}</li>
        <li>{t('form.register.usp.usp_2')}</li>
        <li>{t('form.register.usp.usp_3')}</li>
        <li>{t('form.register.usp.usp_4')}</li>
        <li>{t('form.register.usp.usp_5')}</li>
      </ul>

      <CoreLink to={ROUTE_CUSTOMER_SERVICE}>
        {t('general.more_information')}
      </CoreLink>
    </div>
  );
};

export default CheckoutRegister;
